export default __webpack_public_path__ + "static/media/33.a99ea4b7.jpg";